<template>
    <div class="password-dialog">
        <HLCardLayout class="pt-0" :class="{'fixed-width': !isXsDevice, 'full-width': isXsDevice}" :scale="(isXsDevice)?0.75:(isXlDevice)?0.4:0.7" :loading="false" :minHeight="(isSmAndUpDevice)?'600':null" disableFooterPadding :horizontalMargin="!isXsDevice">
            <template #header-action>
                <!-- close btn -->
            </template>

            <template #menuTitle>
                <h3 class="three-dots px-sm-6 grey--text text--darken-3" :class="{'text-center':true}" :style="{'color': theme.textColor + '!important'}">{{$t('loginPassword')}}</h3>
            </template>

            <!-- Content -->
            <template #content>
                <div class="password-input-container pa-4">
                    <div class="content-wrapper">
                        <!-- Lock Icon -->
                        <div class="lock-icon-container mb-6 mb-sm-8 mb-md-12">
                            <v-icon 
                                class="lock-icon" 
                                size="48"
                                :color="theme.textColor"
                                :style="{'border-color': theme.textColor + '!important'}"
                            >
                                mdi-lock
                            </v-icon>
                        </div>

                        <div class="text-center mb-4 mb-sm-6" :style="{'color': theme.textColor}">
                            {{$t('passwordEnter')}}
                        </div>
                        
                        <v-text-field
                            v-model="password"
                            :label="$t('password')"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPassword = !showPassword"
                            outlined
                            :color="theme.textColor"
                            :style="{'color': theme.textColor}"
                            @keyup.enter="onSubmit"
                            ref="passwordInput"
                            :error="hasError"
                            :error-messages="errorMessage"
                        ></v-text-field>
                    </div>

                    <div class="text-center mt-4 button-container">
                        <v-btn
                            @click="onSubmit"
                            large
                            block
                            depressed
                            rounded
                            :color="theme.btnColorPrimary"
                            :disabled="!password || isLoading"
                            class="mb-3"
                        >
                            {{$t('ok')}}
                        </v-btn>
                        
                        <v-btn
                            @click="onCancel"
                            large
                            block
                            depressed
                            rounded
                            dark
                            :opacity="0.8"
                        >
                            {{$t('close')}}
                        </v-btn>
                    </div>
                </div>
            </template>

        </HLCardLayout>
    </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {spotMixin} from '@/utils/spot-mixin'
import HLCardLayout from '@/components/dashboard/HLCardLayout.vue'

export default {
    mixins: [layoutMixin, spotMixin],
    components:{
        HLCardLayout
    },
    data(){
        return {
            password: '',
            showPassword: false,
            isLoading: false,
            hasError: false,
            errorMessage: ''
        }
    },
    computed: {
    },
    methods: {
        onSubmit(){
            if (!this.password || this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.hasError = false;
            this.errorMessage = '';
            try{
                const spot = this.getSpotByPassword(this.password);
                if (spot) {
                    this.onClose(spot );
                } else {
                    this.hasError = true;
                    this.errorMessage = this.$t('passwordWrong');
                }
            } catch(e) {
                this.hasError = true;
                this.errorMessage = this.$t('error_generic');
            } finally {
                this.isLoading = false;
            }
        },
        onCancel(){
            this.$emit('cancel');
        },
        onClose(spot){
            this.$emit('success', spot);
        },
        reset(){
            this.password = '';
            this.showPassword = false;
            this.isLoading = false;
            this.hasError = false;
            this.errorMessage = '';
        },
        assignPseudoElementStyle() {
            document.documentElement.style.setProperty('--border-color', this.theme.textColor);
        }
    },
    mounted() {
        this.reset();
        this.$nextTick(() => {
            if (this.$refs.passwordInput) {
                this.$refs.passwordInput.focus();
            }
        });
    },
    created() {
        this.assignPseudoElementStyle();
    }
}
</script>

<style lang="scss">
.password-input-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .v-text-field {
        .v-input__control {
            .v-input__slot {
                background-color: rgba(255, 255, 255, 0.1);
                fieldset {
                    border-color: var(--border-color) !important;
                }
            }
        }
        .v-text-field__slot input {
            color: var(--border-color) !important;
        }
        .v-label {
            color: var(--border-color) !important;
        }
        .v-input__append-inner .v-icon {
            color: var(--border-color) !important;
        }
    }
}

.button-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.lock-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    
    .lock-icon {
        border-radius: 50%;
        padding: 16px;
        border: 2px solid;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.fixed-width {
    width: 680px;
    max-width: 90vw;
}
.full-width {
    width: 100vw;
    max-width: 100vw;
}
</style>
